import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../../../components/CountrySwitch/components/CountrySwitchMobile/components/LabelCountry/components/Container.js';
import { MaskedLink } from '../../../../../../components/internal/MaskedLink/index.js';
import { NextImage } from '../../../../../../components/internal/NextImage/index.js';
import { LabelMedium, Stack } from '../../../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../../../utils/directus.js';
export const LabelCountry = ({
  item
}) => {
  return _jsx(Container, {
    children: _jsx(MaskedLink, {
      href: item.domain,
      children: _jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [_jsx(LabelMedium, {
          children: item.name
        }), _jsx(NextImage, {
          width: 21,
          height: 15,
          image: useDirectusImageUrl(item?.icon?.url),
          alt: ""
        })]
      })
    })
  });
};